module.exports = __webpack_public_path__ + "media/images/thanks/d-af6f483c3a7b805ef09abad5755ddcb1.jpg";